// Die Anwesenheitsliste (task-016, docs/architektur-paket-2.md, Abschnitt „Client“, `hud/`): wer
// gerade da ist, solange Tab gehalten wird, und im Menü. Wer abwesend oder abgemeldet ist, fehlt – das
// entscheidet der Server mit `playerJoined` und `playerLeft` (game/remotePlayers.ts).
//
// `anwesenheitsZeilen` ist reine Logik und geprüft; die Ansicht rührt das DOM nur an, wenn sich die
// Zeilen geändert haben, damit der Aufruf je Bild nichts kostet.

/** Eine Zeile der Liste. */
export interface AnwesenheitsZeile {
  name: string;
  /** Ob man selbst es ist. */
  du: boolean;
}

/** Man selbst zuerst, dann die anderen nach Namen – Groß- und Kleinschreibung egal. */
export function anwesenheitsZeilen(eigenerName: string, andere: readonly { name: string }[]): AnwesenheitsZeile[] {
  const sortiert = [...andere].sort((a, b) => a.name.localeCompare(b.name, 'de', { sensitivity: 'base' }));
  return [{ name: eigenerName, du: true }, ...sortiert.map((mitspieler) => ({ name: mitspieler.name, du: false }))];
}

export interface Anwesenheitsliste {
  /** Zeigt die Liste mit diesen Zeilen oder blendet sie aus; darf je Bild aufgerufen werden. */
  zeige(sichtbar: boolean, zeilen: readonly AnwesenheitsZeile[]): void;
  dispose(): void;
}

export function createAnwesenheitsliste(parent: HTMLElement): Anwesenheitsliste {
  const wurzel = document.createElement('div');
  wurzel.className = 'hud-liste';
  wurzel.hidden = true;
  const titel = document.createElement('h2');
  titel.textContent = 'Wer ist da';
  const liste = document.createElement('ul');
  wurzel.append(titel, liste);
  parent.append(wurzel);
  const fuelle = listenFueller(liste);

  return {
    zeige(sichtbar, zeilen) {
      if (wurzel.hidden === sichtbar) wurzel.hidden = !sichtbar;
      if (sichtbar) fuelle(zeilen);
    },
    dispose() {
      wurzel.remove();
    },
  };
}

/** Füllt eine Liste mit den Zeilen, aber nur, wenn sie sich geändert haben; das Menü nimmt dasselbe. */
export function listenFueller(liste: HTMLUListElement): (zeilen: readonly AnwesenheitsZeile[]) => void {
  let zuletzt = '';
  return (zeilen) => {
    const schluessel = JSON.stringify(zeilen);
    if (schluessel === zuletzt) return;
    zuletzt = schluessel;
    liste.replaceChildren(
      ...zeilen.map((zeile) => {
        const eintrag = document.createElement('li');
        eintrag.textContent = zeile.name;
        if (zeile.du) {
          const du = document.createElement('span');
          du.className = 'hud-liste-du';
          du.textContent = ' (du)';
          eintrag.append(du);
        }
        return eintrag;
      }),
    );
  };
}
